export default "__VITE_ASSET__DGxc450J__"